// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var $ = require("jquery");

var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var $chart = $('#all-countries');

var $toolTip = $('#tooltip')
  .hide();

$chart.on('mouseenter', 'g[id]', function() {
  var name = this.getAttribute("id");
  $(this).find( "path" ).css( "fill", "#fadd1d" );
  var $name = $(this);
  $toolTip.html(ich.popup(areaData[name])).show();
});

$chart.on('mouseleave', 'g', function() {
    $(this).find( "path" ).removeAttr('style');
  $toolTip.hide();
});

$chart.on('mousemove', function(e) {
  var bounds = $chart[0].getBoundingClientRect();
  var mouse = {
    left: e.clientX,
    top: e.clientY
  };
  var tWidth = $toolTip.width();
  var position = {
    left: mouse.left - bounds.left - tWidth / 2 - 30,
    top: mouse.top - bounds.top - $toolTip.height() + 30
  };
  if (position.left < 0) position.left = 0;
  if (position.left + tWidth > bounds.width) position.left = bounds.width - tWidth;
  position.left += "px";
  position.top += "px";
  $toolTip.css(position);
});

$(".map-graphic").on("click", ".close-button", function() {
  $toolTip.hide();
});
